<template>
  <span class="h2 m-0 text-uppercase">
    {{ initials }}
  </span>
</template>

<script>

export default {
  name: 'block-with-initials',
  props: {
    name: {
      type: String,
      default: null,
    },
  },
  computed: {
    initials () {
      const name = this.name || '';
      const splittedString = name.split(' ');

      if (splittedString[0].length < 2) {
        return name + name || 'xx';
      } else if (splittedString.length === 1) {
        return splittedString[0].slice(0, 2);
      } else if (splittedString.length >= 2) {
        return splittedString[0][0] + splittedString[1][0];
      }

      return 'xx';
    },
  },
};

</script>

<style lang="scss"></style>
